export default __webpack_public_path__ + "static/media/donation2.2ae87ea6.gif";